import React from 'react';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const userLang = navigator.language || navigator.userLanguage;

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = userLang === 'zh-CN' ? '确认操作' : 'Confirm Action',
  message = userLang === 'zh-CN' ? '您确定要执行此操作吗？' : 'Are you sure you want to perform this action?'
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
    >
      <div className="p-6">
        <p className="mb-4">{message}</p>
        <div className="flex justify-end space-x-4">
          <Button variant="secondary" onClick={onClose}>
            {userLang === 'zh-CN' ? '取消' : 'Cancel'}
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            {userLang === 'zh-CN' ? '确定' : 'Confirm'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal; 